import { render, staticRenderFns } from "./AnswerRequiredField.vue?vue&type=template&id=28041556&scoped=true&"
import script from "./AnswerRequiredField.vue?vue&type=script&lang=js&"
export * from "./AnswerRequiredField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28041556",
  null
  
)

export default component.exports